import type { DomainDataProfile } from '../../../core/data-profiles';

export function reverseFieldMapping(
  universalProps: Record<string, unknown>,
  profile: DomainDataProfile
): Record<string, unknown> {
  const mapped: Record<string, unknown> = {};

  Object.entries(universalProps).forEach(([prop, value]) => {
    const aliases = profile.fieldAliases[prop];
    const externalColumn = aliases?.[0] ?? prop;
    mapped[externalColumn] = value;
  });

  return mapped;
}
